import React, { useMemo, useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
// import { ArrowRightOutlined } from "@ant-design/icons";
import arrowright from "../../../assets/arrowright.svg";
import Vectorsorting from "../../../assets/Vectorsorting.svg";
// import { Image } from "antd";
import { useNavigate } from "react-router";
import ShimmerLoader from "../../../loading";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import CustomPagination from "../../../components/CustomWidgets/CustomPagination";

const AllProductsTable = ({ tabledata, pagination }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [flag, setflag] = useState(false);
  const is_lahloob = useSelector(
    (state) => state.login?.user?.result?.is_lahloob
  );

  const lang = i18n.language;

  console.log("TABLE  DATA _------>", tabledata);

  const data = useMemo(() => {
    if (Array.isArray(tabledata)) {
      return tabledata;
    } else if (tabledata && typeof tabledata === "object") {
      return [];
    }
    return [];
  }, [tabledata]);

  useEffect(() => {
    if (data.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [data, flag]);

  const columns = useMemo(
    () => [
      {
        Header: t("Order Date"),
        accessor: "order_date",
        width: '10%',
        Cell: ({ value }) => value || "0",
      },
      {
        Header: t("Barcode"),
        width: '10%',
        accessor: "barcode",
      },
      {
        Header: t("Product Name"),
        width: '19%',
        accessor: "product_name",
          Cell: ({ row }) => (
          <div className="text-start">{row.original.product_name2 && row.original.product_name2 != '' ?  row.original.product_name2 : row.original.product_name}</div>
        ),
      },
      {
        Header: t("Purchase Price"),
        width: '8%',
        accessor: "purchase_price",
        Cell: ({ value }) => `EGP ${value?.toFixed(2)} `,
      },
      {
        Header: t("Sale Price"),
        width: '8%',
        accessor: "sale_price",
        Cell: ({ value }) => `EGP ${value ? value?.toFixed(2) : '-'} `,
      },
      // {
      //   Header: t("Profit %"),
      //   width: '6%',
      //   accessor: "profit",
      //   Cell: ({ value }) => `${value?.toFixed(2)} %`,
      // },
      {
        Header: t("Profit %"),
        width: '6%',
        accessor: "profit",
        Cell: ({ value }) => {
          const formattedValue = value?.toFixed(2) || "0.00";
          const lang = i18n.language;

          return lang === "ar"
            ? `% ${formattedValue}`
            : `${formattedValue} %`;
        },
      },
      {
        Header: t("Quantity Purchased"),
        width: '10%',
        accessor: "quantity",
        Cell: ({ value }) => `${value}`,
      },
      {
        Header: t("Daily Avg. Sale"),
        width: '10%',
        accessor: "daily_avg_sale",
        Cell: ({ value }) => `${value?.toFixed(2)}`,
      },
      {
        Header: t("Inventory in Days"),
        width: '10%',
        accessor: "inv_in_days",
      },
    ],
    [t]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination
  );

  const [pageIndex, setpageIndex] = useState(1);


  useEffect(() => {
    const pageDetails = {
      limit: pageSize,
      offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
    };

    if (pageSize) pagination(pageDetails);
  }, [pageSize, pageIndex]);


  return (
    <>
      <div
        className="container mx-auto float-left h-[100%]"
        style={{ maxWidth: "100%" }}
      >

        {tabledata?.length == 0 && flag == false ? (
          <div className="h-screen w-[90%] mt-2 ">
            <ShimmerLoader />
          </div>
        ) : (
          <>
            {/* Header Table (Fixed) */}
            <div>
              <table
                className="font-normal w-full overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr
                      {...headerGroup.getHeaderGroupProps()}
                      className="bg-[#78CFEC66] text-sm font-semibold text-start"
                    >
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps(column.getSortByToggleProps())}
                          className="py-3 px-2 text-sm"
                          style={{ width: column.width, textAlign: "left" }} // Ensure left alignment
                        >
                          <div className="flex items-start">
                            {column.render("Header")}
                            <span className="ms-2">
                              {column.isSorted ? (
                                column.isSortedDesc ? (
                                  <img
                                    src={Vectorsorting}
                                    style={{ minHeight: 10, minWidth: 10 }}
                                    alt="vector"
                                  />
                                ) : (
                                  <img
                                    className="rotate-180"
                                    src={Vectorsorting}
                                    alt="vector"
                                  />
                                )
                              ) : (
                                ""
                              )}
                            </span>
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
              </table>
            </div>

            {/* Table Body */}
            <div className="scrollbar-none bg-white" style={{ overflowY: "auto", maxHeight: "650px" }}>
              <table
                className="font-normal w-full overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <tbody className="bg-[#F7F9FD] text-start overflow-hidden">
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <tr
                        {...row.getRowProps()}
                        className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300"
                      >
                        {row.cells.map((cell, index) => (
                          <td
                            key={index}
                            {...cell.getCellProps()}
                            className="p-2 text-[#272728] text-sm font-normal"
                            style={{ width: cell.column.width }} // Ensure consistency with column width
                          >
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                  {page.length === 0 && (
                    <tr>
                      <td colSpan={100}>
                        <Empty className="mt-10" description={t("No data available")} />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            <div className="">
              <CustomPagination
                data={data?.length}
                pageIndex={pageIndex}
                pageCount={page?.length}
                canPreviousPage={pageIndex != 1 ? true : false}
                canNextPage={data?.length == pageSize ? true : false}
                gotoPage={(page) => {
                  nextPage(page);
                }}
                previousPage={() => {
                  setpageIndex(pageIndex - 1);
                }}
                nextPage={() => {
                  setpageIndex(pageIndex + 1);
                }}
                pageSize={pageSize}
                setPageSize={(pageSize) => {
                  setPageSize(pageSize);
                }}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AllProductsTable;
